import {
    Content,
    Icon,
    Item,
    ItemIndicator,
    ItemText,
    Portal,
    Root,
    ScrollDownButton,
    ScrollUpButton,
    Trigger,
    Value,
    Viewport,
} from '@radix-ui/react-select';
import React from 'react';

import IconChevron from '$partials/icons/icon-chevron';

const NULL_VAL = '---';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/fields.d.ts').Select}
 */
export const Select = ({
    ariaLabel,
    contentClassName,
    contentPosition,
    contentSide,
    contentAlign = 'center',
    contentSideOffset,
    contentAlignOffset,
    displayValue,
    name,
    onChange,
    options,
    placeholder = 'Select...',
    triggerClassName,
    value
}) => {
    /** @type {(value: string) => void} */
    const handleChange = (value) => {
        if (typeof onChange === 'function') {
            onChange(value === NULL_VAL ? null : value);
        }
    };

    return (
        <Root
            name={name}
            onValueChange={handleChange}
            value={value !== null ? String(value) : NULL_VAL}>
            <Trigger
                aria-label={ariaLabel}
                className={`select__trigger${triggerClassName ? ` ${triggerClassName}` : ''}`}>
                <Value placeholder={placeholder}>
                    {displayValue}
                </Value>
                <Icon className='select__icon ml-5'>
                    <IconChevron />
                </Icon>
            </Trigger>
            <Portal>
                <Content
                    align={contentAlign}
                    alignOffset={contentAlignOffset}
                    className={`select__content${contentClassName ? ` ${contentClassName}` : ''}`}
                    position={contentPosition}
                    side={contentSide}
                    sideOffset={contentSideOffset}>
                    <ScrollUpButton className='select__scroll_button'>
                        <IconChevron className='rotate-180' />
                    </ScrollUpButton>

                    <Viewport className='select__viewport'>
                        {options?.map((option, i) => {
                            return (
                                <Item
                                    className='select__item'
                                    disabled={option.disabled}
                                    key={`${option.value}-${i}`}
                                    value={option.value !== null ? String(option.value) : NULL_VAL}>
                                    <ItemText>
                                        {option.label}
                                    </ItemText>
                                    <ItemIndicator className='select__indicator'>
                                        ✓
                                    </ItemIndicator>
                                </Item>
                            );
                        })}
                    </Viewport>

                    <ScrollDownButton className='select__scroll_button'>
                        <IconChevron />
                    </ScrollDownButton>
                </Content>
            </Portal>
        </Root>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Select;
